import KeywordList from './KeywordList';

import { useSearchParams } from '@popularKeyword/common-hooks';

type KeywordColumnProps = {
  data: any;
  isCategoryKeyword?: boolean;
};

const KeywordColumn = ({ data, isCategoryKeyword = false }: KeywordColumnProps) => {
  const params = useSearchParams();
  const { type } = params;

  const rankingCountPerColumn = type === 'detail' ? 100 : 10;

  const startRanking = Number(data[0].rank);
  const endRanking = startRanking + rankingCountPerColumn - 1;
  const keywordColumnTitle = `${startRanking}위~${endRanking}위`;

  return (
    <div className="c-keyword">
      <div className="c-p-headline">
        {isCategoryKeyword ? (
          <h5 className="c-p-headline__title">{keywordColumnTitle}</h5>
        ) : (
          <h4 className="c-p-headline__title">{keywordColumnTitle}</h4>
        )}
      </div>
      <KeywordList data={data} />
    </div>
  );
};

export default KeywordColumn;
